import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import FeaturesContent from '../components/Features/FeaturesContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../redux/language/selector'

const Features = () => {
    const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('features-page.features-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])

    return (
        <>
        
            <NavbarTop/>
            <FeaturesContent/>
            {/* <Footer/>
            <NavbarBottom/> */}
        </>
      
    )
}

export default Features